<app-layer-button
  class="position-absolute bottom-7 start-5 z-2"
  (visibilityToggled)="toggleLayerSwitchVisibility()"
>
</app-layer-button>

<div class="position-absolute bottom-7 start-5 z-2 pt-2" [class.d-none]="!isLayerSelectionVisible">
  <app-layer-config>
    <div class="d-flex flex-column categories">
      <app-obstacle-segment-data> </app-obstacle-segment-data>
      <app-layer-config-collapsible-category description="OEM" storageKey="obstacle-oem">
        <div class="d-flex flex-column w-100">
          <app-obstacle-provider4-data
            [providerInfo$]="this.providerInfo$"
          ></app-obstacle-provider4-data>
          <app-obstacle-provider8-data
            [providerInfo$]="this.providerInfo$"
          ></app-obstacle-provider8-data>
          <app-obstacle-provider9-data
            [providerInfo$]="this.providerInfo$"
          ></app-obstacle-provider9-data>
          <app-obstacle-provider6-data
            [providerInfo$]="this.providerInfo$"
          ></app-obstacle-provider6-data>
        </div>
      </app-layer-config-collapsible-category>
      <app-layer-config-collapsible-category description="NRA" storageKey="obstacle-nra">
        <div class="d-flex flex-column w-100">
          <app-obstacle-provider3-data
            [providerInfo$]="this.providerInfo$"
          ></app-obstacle-provider3-data>
          <app-obstacle-provider7-data
            [providerInfo$]="this.providerInfo$"
          ></app-obstacle-provider7-data>
        </div>
      </app-layer-config-collapsible-category>
      <app-layer-config-collapsible-category
        description="Providers"
        storageKey="obstacle-providers"
      >
        <div class="d-flex flex-column w-100">
          <app-obstacle-provider1-data
            [providerInfo$]="this.providerInfo$"
          ></app-obstacle-provider1-data>
          <app-obstacle-provider2-data
            [providerInfo$]="this.providerInfo$"
          ></app-obstacle-provider2-data>
        </div>
      </app-layer-config-collapsible-category>
    </div>
  </app-layer-config>
</div>
